// extracted by mini-css-extract-plugin
module.exports = {"remove":"Rules_remove__3kpWF","disabled":"Rules_disabled__2fKXB"};